import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BaseDecarbFooterBar } from '../components/BaseDecarbFooterBar';
import { usePencilsDown } from '../hooks/usePencilsDown';
import { Tab } from '../types';

type Props = {
  currentTab: Tab;
  changeTab: (nextTab: Tab) => void;
  saveSubproject: (onSuccessFn: () => void) => void;
};

export const DecarbFooterBar: React.FC<Props> = ({
  currentTab,
  changeTab,
  saveSubproject,
}) => {
  const navigate = useNavigate();
  const pencilsDown = usePencilsDown();

  const onBackClick = () => {
    try {
      if (currentTab === 'conventionalAlternative') {
        saveSubproject(() => navigate('../'));
      } else if (currentTab === 'reducedCarbonAlternative') {
        changeTab('conventionalAlternative');
      } else {
        changeTab('reducedCarbonAlternative');
      }
    } catch (error) {
      console.error('Failed to save:', error);
      alert('Failed to save changes. Please try again.');
    }
  };

  const onNextClick = () => {
    try {
      if (currentTab === 'conventionalAlternative') {
        changeTab('reducedCarbonAlternative');
      } else if (currentTab === 'reducedCarbonAlternative') {
        changeTab('zeroCarbonAlternative');
      } else {
        saveSubproject(() => navigate('../'));
      }
    } catch (error) {
      console.error('Failed to save:', error);
      alert('Failed to save changes. Please try again.');
    }
  };

  return (
    <BaseDecarbFooterBar
      backText={
        currentTab === 'conventionalAlternative' ? 'RETURN TO HUB' : 'BACK'
      }
      onBackClick={onBackClick}
      nextText={
        currentTab === 'zeroCarbonAlternative' ? 'FINISH & RETURN' : 'NEXT'
      }
      onNextClick={onNextClick}
      onReturnToHubClick={() => {
        try {
          saveSubproject(() => navigate(`../`));
        } catch (error) {
          console.error('Failed to save:', error);
          alert('Failed to save changes. Please try again.');
        }
      }}
      returnText= {pencilsDown
          ? 'RETURN TO DECARBONIZATION HUB'
          : 'SAVE & RETURN TO DECARBONIZATION HUB'}
    />
  );
};
